import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import BackButton from '../../../components/Buttons/BackButton';
import TitleLayout from '../../../components/layout/TitleLayout';
import SkeletonWrapper from '../../../components/Skeletons/SkeletonWrapper';
import RenderForm from '../../../components/TemplatesForms/RenderForm';
import Theme from '../../../Themes/main.theme';
import {useNavigate} from 'react-router-dom';
import LinesSkeleton from '../../../components/Skeletons/LinesSkeleton';
import HorizontalWrapper from '../../../components/Details/HorizonticalWrapper';
interface Props {
    formValues: any;
    basic_info: any;
    formTitle: string;
    isLoading: boolean;
}

function SpecificFormDetails(props: Props) {
  const { formValues, basic_info, formTitle } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  document.title = t('Βασικές Πληροφορίες Αιτήματος');

  return (<>
    <Box mt={2} mb={2}>
      <BackButton onClick={() => navigate(-1)}/>
    </Box>
    <Typography variant='h2' sx={{ my: 2 }}
      color={Theme?.labelColor?.main}>{formTitle || ''}
    </Typography>

    <TitleLayout>
      <Box>
        <Box sx={{ backgroundColor: Theme.labelColor?.background, py: 1, pl: 1, ml: 1, my: 2 }}>
          <Typography variant='h3' color={Theme.labelColor?.main}>
            {t('Βασικές Πληροφορίες Αιτήματος')}       
          </Typography>
        </Box>
        {props.isLoading ?
          <LinesSkeleton lines={3}/> :
          <HorizontalWrapper 
            title = {''}
            details={basic_info}
            marginLeft />}
      </Box>

      <Box display='flex' justifyContent='center'
        mt={3}>
        <SkeletonWrapper loading={props.isLoading} skeletonLines={5}>
          {formValues && <RenderForm disabled={true} metadataArray={formValues} />}
        </SkeletonWrapper>
      </Box>

    </TitleLayout>

  </>);
}

export default SpecificFormDetails;